<div class="date">
    <div [innerHTML]="date | date: 'MMM'"></div>
    <div [innerHTML]="date | date: 'dd'"></div>
</div>
